import { UsersStoreType } from '@/types/store/users-store.type';

export const state: UsersStoreType = {
  users: null,
  user: null,
  userStatistics: null,
};
